import { HttpContextToken } from '@angular/common/http';

export const BYPASS_REQUEST_SOURCE_INTERCEPTOR = new HttpContextToken<boolean>(
  () => false,
);
